import { useDispatch } from 'react-redux'
import { bindActionCreators } from '@reduxjs/toolkit'
import { authActions } from '../store/auth/auth.slice'
import { trucksActions } from '../store/trucks/trucks.slice'
import { commonActions } from '../store/common.slice'

const actions = {
	...authActions,
	...trucksActions,
	...commonActions,
}

export const useActions = () => {
	const dispatch = useDispatch()
	return bindActionCreators(actions, dispatch)
}
